function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M132.9,54.8a13,13,0,0,1-9.2-3.2,11,11,0,0,1-3.4-8.3V28.5h-5.1V20.8h5.1V11.6l9.6-1V20.8H135v7.7h-5.1V41.9a5.38,5.38,0,0,0,1.1,3.8,3.77,3.77,0,0,0,3,1.1,23.36,23.36,0,0,0,2.6-.4l2,6.8A10.46,10.46,0,0,1,132.9,54.8Z",
  fill: "#2C3038"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M153.1,24.5a11.94,11.94,0,0,1,8.9-3.8,17.33,17.33,0,0,1,3.2.3l-1.5,9.4a6.82,6.82,0,0,0-4.8-1.6c-2.3.2-4.2,1.8-5.8,5.1V54.8h-9.5V21.7l9.5-1Z",
  fill: "#2C3038"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M169.6,37.8a16.33,16.33,0,0,1,15.7-17h1.3c5,0,9,1.6,11.9,4.8A17.58,17.58,0,0,1,203,37.8v3.4H179.5a6.28,6.28,0,0,0,2.4,4.3,7.61,7.61,0,0,0,4.8,1.5,14.12,14.12,0,0,0,8.5-2.7l5.4,5.5c-2.5,3.4-7.2,5.1-14,5.1a16.33,16.33,0,0,1-17-15.7V37.8Zm21.8-7.7a8.27,8.27,0,0,0-9.5,0,5.08,5.08,0,0,0-2,4.3h13.6A4.92,4.92,0,0,0,191.4,30.1Z",
  fill: "#2C3038"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M220,33.1V54.8h-9.5V21.7l9.5-1v3.1a12.3,12.3,0,0,1,8.2-3.1q6.45,0,9.9,3.9a13.62,13.62,0,0,1,3.4,9V54.7H232V36a7.85,7.85,0,0,0-1.7-5.3,6.63,6.63,0,0,0-5.1-2C223.1,28.9,221.4,30.4,220,33.1Z",
  fill: "#2C3038"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M281.6,21.7V52a17.46,17.46,0,0,1-4.2,12,14.77,14.77,0,0,1-10.7,5.1l-2,.2c-6.6-.1-11.7-2-15.3-5.6l4.4-5.1a17.43,17.43,0,0,0,9.1,3.1c3.6,0,6.1-.9,7.4-2.6a9.45,9.45,0,0,0,1.9-5.6V51.8a14.16,14.16,0,0,1-8.9,3.1c-5.2,0-9.1-1.5-11.8-4.6s-3.9-7.2-3.9-12.4c0-5,1.4-9.1,4.3-12.3s6.9-4.8,12.1-4.8c3.9.2,6.6,1.3,8.2,3.1V20.8Zm-9.5,19.1V35.3c-.5-3.8-2.8-6-7.2-6.7-5.7.2-8.7,3-9.2,8.5.2,6.4,3.3,9.7,9.2,9.9C269.3,46.3,271.7,44.2,272.1,40.8Z",
  fill: "#2C3038"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M291.5,50.1a16.9,16.9,0,0,1-5-12.4,17.4,17.4,0,0,1,34.8,0h0a17.54,17.54,0,0,1-17.7,17.4,17,17,0,0,1-12.1-5Zm12.3-3.2a8.23,8.23,0,0,0,6.3-2.6,9.22,9.22,0,0,0,2.4-6.5,9.22,9.22,0,0,0-2.4-6.5,7.9,7.9,0,0,0-6.3-2.6,8.23,8.23,0,0,0-6.3,2.6,9.22,9.22,0,0,0-2.4,6.5,9.22,9.22,0,0,0,2.4,6.5A8.23,8.23,0,0,0,303.8,46.9Z",
  fill: "#2C3038"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M49.8.5C-25.6,7.1-.4,45.5,28.5,62.4c29.4,17.2,43.1,20.3,60.2-6.3C88.7,56.1,125.1-6.1,49.8.5ZM30.9,37.1a4.37,4.37,0,0,1,4.4-4.4H57.6A4.37,4.37,0,0,1,62,37.1a4.44,4.44,0,0,1-4.4,4.4H35.3A4.37,4.37,0,0,1,30.9,37.1ZM71.6,54.2h-30a4.37,4.37,0,0,1-4.4-4.4,4.44,4.44,0,0,1,4.4-4.4h30a4.4,4.4,0,1,1,0,8.8Zm0-25.3H28a4.37,4.37,0,0,1-4.4-4.4A4.44,4.44,0,0,1,28,20.1H71.5a4.37,4.37,0,0,1,4.4,4.4A4.29,4.29,0,0,1,71.6,28.9Z",
  fill: "#2C3038"
});

const SvgTrengo = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 321,
  height: 75,
  viewBox: "0 0 321.28 75.69",
  fill: "none",
  className: "injected-svg mr-4",
  "data-src": "https://trengo.com/themes/version2/assets/img/logos/trengo.svg",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrengo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/trengo.f5917191.svg";
export { ForwardRef as ReactComponent };